export default {

    methods: {
        setUpNavItems() {
            const items = this.nav;

            items.forEach(element => {
            const check = element.access_check;
            if (check && typeof check === 'function') {
                element.access_check = check.callback(check.value);
            }

            });
            this.nav = items;
        }
    },

}